var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"action-loader"},[_c('vue-loaders',{class:_vm.loaderClass,attrs:{"name":_vm.name,"scale":_vm.size,"color":_vm.color}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }